import { render } from "./AlexandraVeronicaMengheresPage.vue?vue&type=template&id=2bf4aec4"
import script from "./AlexandraVeronicaMengheresPage.vue?vue&type=script&lang=js"
export * from "./AlexandraVeronicaMengheresPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__